import { Link } from 'react-router-dom';
import '../styles/Footer.css'; // Import your styles
import ServerStatus from '../middleware/mcstats';
import { EXTERNAL, SERVER_IP } from '../config/links';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    });
  };
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src="/favicon.ico" alt="ISN Logo" />
          <p>{SERVER_IP}</p>
          <ServerStatus /> <p>ONLINE</p>
        </div>
        <div className="footer-social">
          <a href={EXTERNAL.discord} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-discord"></i>
          </a>
          <a href={EXTERNAL.youtube} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
          <a href={EXTERNAL.instagram} target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-column">
          <h3>ABOUT US</h3>
          <p>
            ISN Network was founded in 2016 by the ISN team and has developed its own community ever since! We're a developing server with a lot of features and a friendly community. We aim to provide the best experience for our players.'
          </p>
        </div>
        <div className="footer-column">
          <h3>LINKS</h3>
          <ul>
            <li><button onClick={scrollToTop} className='link-Back-To-Top'>Back to Top</button></li>
            <li><a href={EXTERNAL.discord} target="_blank" rel="noopener noreferrer">Contact Us</a></li>
            <li><Link to="/rules">Rules</Link></li>
            <li><Link to="/staff">Staff</Link></li>
            <li><Link to="/wiki">Wiki</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>SUPPORT US</h3>
          <p>
            If you enjoy playing, feel free to support us by purchasing some packages, ranging from crate keys to permanent ranks.
          </p>
          <a href={EXTERNAL.store} className="footer-button" target="_blank" rel="noopener noreferrer">Visit Store</a>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-copyright">
        <p>&copy; 2025 ISN Network. All rights reserved.</p>
        <p>We are not affiliated with Mojang or Minecraft.</p>
      </div>
    </footer>
  );
};

export default Footer;